import React from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';

const FinalData = ({
  conclusions,
  onChange,
  percentage,
  recommendations,
  results,
}) => {
  return (
    <>
      <InputText
        name='percentage'
        value={percentage}
        label='Porcentaje de avance *'
        size='small'
        variant='outlined'
        onChange={onChange}
        placeholder='9%'
        margin='normal'
      />
      <InputText
        name='results'
        value={results}
        multiline
        maxRows={3}
        label='Resultados'
        size='small'
        variant='outlined'
        onChange={onChange}
        placeholder='Ingrese los resultados que obtuvos al ejecutar sus actividades'
        margin='normal'
      />
      <InputText
        name='conclusions'
        value={conclusions}
        multiline
        maxRows={3}
        label='Conclusiones'
        size='small'
        variant='outlined'
        onChange={onChange}
        placeholder='Ingrese las conclusiones'
        margin='normal'
      />
      <InputText
        name='recommendations'
        value={recommendations}
        multiline
        maxRows={3}
        label='Recomendaciones'
        size='small'
        variant='outlined'
        onChange={onChange}
        placeholder='Ingrese las recomendaciones.'
        margin='normal'
      />
    </>
  );
};

const InputText = styled(TextField)`
  width: 90%;
`;

export default FinalData;
